import * as proformaUploadTypes from './proformaUploadTypes';

const initialState = {
  downloadProformaTempSuccess: false,
  downloadProformaTempPending: false,
  tableData: [],
  filters: {},
  showFilterModal: false,
  documents: [],
  importJobId: 0,
  proformaUploadPending: false,
  isUploadError: false,
};

const proformaUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case proformaUploadTypes.DOWNLOAD_PROFORMA_TEMPLATE_PENDING:
      return {
        ...state,
        downloadProformaTempSuccess: false,
        downloadProformaTempPending: true,
      };
    case proformaUploadTypes.DOWNLOAD_PROFORMA_TEMPLATE_SUCCESS:
      return {
        ...state,
        downloadProformaTempSuccess: action.payload.response.success,
        downloadProformaTempPending: false,
      };
    case proformaUploadTypes.DOWNLOAD_PROFORMA_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadProformaTempSuccess: false,
        downloadProformaTempPending: false,
      };
    case proformaUploadTypes.GET_UPLOADED_PROFORMAS_SUCCESS:
      return { ...state, tableData: action.payload };
    case proformaUploadTypes.GET_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
    case proformaUploadTypes.SET_IMPORT_JOB_ID:
      return {
        ...state,
        importJobId: action.data.jobId,
        proformaUploadPending: false,
        isUploadError: false,
      };
    case proformaUploadTypes.RESET_PROFORMA_UPLOAD:
      return {
        ...state,
        documents: [],
        importJobId: 0,
        isUploadError: false,
      };
    case proformaUploadTypes.PROFORMA_UPLOAD_PENDING:
      return {
        ...state,
        proformaUploadPending: true,
        isUploadError: false,
      };
    case proformaUploadTypes.PROFORMA_UPLOAD_FAILURE:
      return {
        ...state,
        proformaUploadPending: false,
        isUploadError: true,
      };
    case proformaUploadTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    default:
      return state;
  }
};

export { initialState };
export default proformaUploadReducer;
